export const generateClassCode = (): string => {
  const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let code = '';
  
  for (let i = 0; i < 4; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    code += characters[randomIndex];
  }
  
  return `HOPE-${code}`;
};

export const isValidClassCodeFormat = (code: string): boolean => {
  const pattern = /^[A-Z0-9]{4,}-[A-Z0-9]{4,}$/;
  return pattern.test(code.trim().toUpperCase());
};

